import Navbar from "layouts/ecommerce/posnavbar/Navbar";
import DashboardKitchenOS from "./components/dashboard-kitchenOS";
import "./index.css";

export default function KitchenOSDashboard() {
  return (
    <Navbar pageTitle="Kitchen OS">
      <div className="idx_kos_wrapper">
        <DashboardKitchenOS />
      </div>
    </Navbar>
  );
}
